import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePipeline } from '../PipelineContext';

const OPERATOR_LABELS = {
  eq: '=', neq: '≠', gt: '>', gte: '≥', lt: '<', lte: '≤', contains: 'contains',
};

export default function ConditionNode({ id, data, selected }) {
  const [showInfo, setShowInfo] = useState(false);
  const pipeline = usePipeline();
  const { opsMode } = pipeline || {};

  const conditions = data.conditions || [];
  const logic      = data.logic || 'and';
  const headerStyle = data.color ? { background: data.color + '22', color: data.color } : {};
  const nodeStyle   = data.color ? { borderColor: data.color } : {};

  const summaryLine = conditions.length === 0
    ? 'No conditions set'
    : conditions.map(c => `${c.fieldName || c.fieldId || '?'} ${OPERATOR_LABELS[c.operator] || c.operator || '='} "${c.value || ''}"`).join(` ${logic.toUpperCase()} `);

  return (
    <div className={`pipeline-node condition-node ${selected ? 'selected' : ''}`} style={nodeStyle}>
      <Handle type="target" position={Position.Left} className="node-handle" />

      <div className="node-header condition-header" style={headerStyle}>
        <span className="node-type-icon">◇</span>
        <span className="node-type-label">{opsMode ? 'Decision' : 'Condition'}</span>
        <button
          className="node-info-btn"
          onMouseDown={e => e.stopPropagation()}
          onClick={e => { e.stopPropagation(); setShowInfo(s => !s); }}
        >ⓘ</button>
      </div>

      <div className="node-body">
        <div className="node-title">{data.label || 'Condition'}</div>
        {data.description && <div className="node-description">{data.description}</div>}

        {showInfo && (
          <div className="node-info-card">
            <div className="node-info-what">Evaluates a rule against your collection data and routes the workflow down the YES or NO path.</div>
            <div className="node-info-eg-label">Connect from:</div>
            <div className="node-info-eg">→ YES handle (top-right) — condition is true</div>
            <div className="node-info-eg">→ NO handle (bottom-right) — condition is false</div>
          </div>
        )}

        <div className="condition-summary">{summaryLine}</div>

        <div className="condition-handles-legend">
          <span className="condition-yes-label">YES ↗</span>
          <span className="condition-no-label">NO ↘</span>
        </div>
      </div>

      {/* Two source handles: YES (top-right) and NO (bottom-right) */}
      <Handle
        type="source"
        position={Position.Right}
        id="yes"
        className="node-handle condition-handle-yes"
        style={{ top: '35%' }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="no"
        className="node-handle condition-handle-no"
        style={{ top: '65%' }}
      />
    </div>
  );
}
